<div class="main">
    <div class="settings-header">
        <div class="main-title">
            <h1>User Profile Settings</h1>
            <p>Manage your personal information and password</p>
        </div>
    </div>

    <div class="settings-content">
        <div class="settings-card">
            <div class="card-header">
                <h2><i class="fas fa-user"></i> Profile Information</h2>
                <p class="card-subtitle">Update your personal details</p>
            </div>

            <form
                [formGroup]="profileForm"
                (ngSubmit)="onUpdateProfile()"
                class="settings-form"
            >
                <div class="form-row">
                    <div class="form-group">
                        <label for="name"
                            >Name
                            <span class="text-danger-required">*</span></label
                        >
                        <input
                            type="text"
                            id="name"
                            class="form-control"
                            formControlName="name"
                            placeholder="Enter your name"
                        />
                        <div
                            *ngIf="
                                profileFormControls['name'].touched &&
                                profileFormControls['name'].invalid
                            "
                            class="text-danger"
                        >
                            <span
                                *ngIf="
                                    profileFormControls['name'].errors?.[
                                        'required'
                                    ]
                                "
                                >Name is required.</span
                            >
                            <span
                                *ngIf="
                                    profileFormControls['name'].errors?.[
                                        'minlength'
                                    ]
                                "
                                >Name must be at least 2 characters.</span
                            >
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="phone"
                            >Phone Number
                            <span class="text-danger-required">*</span></label
                        >
                        <input
                            type="tel"
                            id="phone"
                            class="form-control"
                            formControlName="phone"
                            pattern="\d*"
                            inputmode="numeric"
                            placeholder="05XXXXXXXX"
                        />
                        <div
                            *ngIf="
                                profileForm &&
                                profileFormControls['phone'].touched &&
                                profileFormControls['phone'].invalid
                            "
                            class="text-danger"
                        >
                            <span
                                *ngIf="
                                    profileFormControls['phone'].errors?.[
                                        'required'
                                    ]
                                "
                                >Phone number is required.</span
                            >
                            <span
                                *ngIf="
                                    profileFormControls['phone'].errors?.[
                                        'pattern'
                                    ]
                                "
                                >Invalid phone number. Must be 10 digits,
                                starting with 05.</span
                            >
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group full-width">
                        <label for="email"
                            >Email Address
                            <span class="text-danger-required">*</span></label
                        >
                        <input
                            type="email"
                            id="email"
                            class="form-control"
                            formControlName="email"
                            placeholder="example@domain.com"
                        />
                        <div
                            *ngIf="
                                profileForm &&
                                profileFormControls['email'].touched &&
                                profileFormControls['email'].invalid
                            "
                            class="text-danger"
                        >
                            <span
                                *ngIf="
                                    profileFormControls['email'].errors?.[
                                        'required'
                                    ]
                                "
                                >Email is required.</span
                            >
                            <span
                                *ngIf="
                                    profileFormControls['email'].errors?.[
                                        'pattern'
                                    ]
                                "
                                >Invalid email format.</span
                            >
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="title"
                            >Title
                            <span class="text-danger-required">*</span></label
                        >
                        <select
                            id="title"
                            class="form-control"
                            formControlName="title"
                        >
                            <option value="" disabled selected>
                                Select Title
                            </option>
                            <option
                                *ngFor="let type of farmTypeOptions"
                                [value]="type.id"
                            >
                                {{ type.name }}
                            </option>
                        </select>
                        <div
                            *ngIf="
                                profileForm &&
                                profileFormControls['title'].touched &&
                                profileFormControls['title'].invalid
                            "
                            class="text-danger"
                        >
                            <span
                                *ngIf="
                                    profileFormControls['title'].errors?.[
                                        'required'
                                    ]
                                "
                                >Title is required.</span
                            >
                        </div>
                    </div>
                </div>

                <div class="form-actions">
                    <button
                        type="submit"
                        class="btn-action-primary"
                        [disabled]="isLoading || profileForm.invalid"
                    >
                        {{ isLoading ? 'Updating...' : 'Update Profile' }}
                    </button>
                </div>
            </form>
        </div>

        <!-- <div class="settings-card">
            <div class="card-header">
                <h2><i class="fas fa-lock"></i> Change Password</h2>
                <p class="card-subtitle">Update your account password</p>
            </div>

            <form
                [formGroup]="passwordForm"
                (ngSubmit)="onUpdatePassword()"
                class="settings-form"
            >
                <div class="form-row">
                    <div class="form-group full-width">
                        <label for="oldPassword"
                            >Old Password
                            <span class="text-danger-required">*</span></label
                        >
                        <div class="password-input-wrapper">
                            <input
                                [type]="showOldPassword ? 'text' : 'password'"
                                id="oldPassword"
                                class="form-control"
                                formControlName="oldPassword"
                                placeholder="Enter your current password"
                            />
                            <button
                                type="button"
                                class="toggle-password"
                                (click)="togglePasswordVisibility('old')"
                            >
                                <i
                                    [class]="
                                        showOldPassword
                                            ? 'fas fa-eye-slash'
                                            : 'fas fa-eye'
                                    "
                                ></i>
                            </button>
                        </div>
                        <div
                            *ngIf="
                                passwordFormControls['oldPassword'].touched &&
                                passwordFormControls['oldPassword'].invalid
                            "
                            class="text-danger"
                        >
                            <span
                                *ngIf="
                                    passwordFormControls['oldPassword']
                                        .errors?.['required']
                                "
                                >Old password is required.</span
                            >
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="newPassword"
                            >New Password
                            <span class="text-danger-required">*</span></label
                        >
                        <div class="password-input-wrapper">
                            <input
                                [type]="showNewPassword ? 'text' : 'password'"
                                id="newPassword"
                                class="form-control"
                                formControlName="newPassword"
                                placeholder="Enter new password"
                            />
                            <button
                                type="button"
                                class="toggle-password"
                                (click)="togglePasswordVisibility('new')"
                            >
                                <i
                                    [class]="
                                        showNewPassword
                                            ? 'fas fa-eye-slash'
                                            : 'fas fa-eye'
                                    "
                                ></i>
                            </button>
                        </div>
                        <div
                            *ngIf="
                                passwordFormControls['newPassword'].touched &&
                                passwordFormControls['newPassword'].invalid
                            "
                            class="text-danger"
                        >
                            <span
                                *ngIf="
                                    passwordFormControls['newPassword']
                                        .errors?.['required']
                                "
                                >New password is required.</span
                            >
                            <span
                                *ngIf="
                                    passwordFormControls['newPassword']
                                        .errors?.['minlength']
                                "
                                >Password must be at least 8 characters.</span
                            >
                            <span
                                *ngIf="
                                    passwordFormControls['newPassword']
                                        .errors?.['pattern']
                                "
                            >
                                Password must include upper and lower letters, a
                                number, and a special character.
                            </span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="confirmPassword"
                            >Confirm New Password
                            <span class="text-danger-required">*</span></label
                        >
                        <div class="password-input-wrapper">
                            <input
                                [type]="
                                    showConfirmPassword ? 'text' : 'password'
                                "
                                id="confirmPassword"
                                class="form-control"
                                formControlName="confirmPassword"
                                placeholder="Confirm new password"
                            />
                            <button
                                type="button"
                                class="toggle-password"
                                (click)="togglePasswordVisibility('confirm')"
                            >
                                <i
                                    [class]="
                                        showConfirmPassword
                                            ? 'fas fa-eye-slash'
                                            : 'fas fa-eye'
                                    "
                                ></i>
                            </button>
                        </div>
                        <div
                            *ngIf="
                                passwordFormControls['confirmPassword']
                                    .touched &&
                                passwordFormControls['confirmPassword'].invalid
                            "
                            class="text-danger"
                        >
                            <span
                                *ngIf="
                                    passwordFormControls['confirmPassword']
                                        .errors?.['required']
                                "
                                >Please confirm your password.</span
                            >
                        </div>
                    </div>
                </div>

                <div class="password-requirements">
                    <p class="requirements-title">
                        <i class="fas fa-info-circle"></i> Password
                        Requirements:
                    </p>
                    <ul>
                        <li>At least 8 characters long</li>
                        <li>Contains at least one uppercase letter</li>
                        <li>Contains at least one lowercase letter</li>
                        <li>Contains at least one number</li>
                        <li>Contains at least one special character</li>
                    </ul>
                </div>

                <div class="form-actions">
                    <button
                        type="submit"
                        class="btn-action-primary"
                        [disabled]="isLoading || passwordForm.invalid"
                    >
                        {{ isLoading ? 'Updating...' : 'Update Password' }}
                    </button>
                </div>
            </form>
        </div> -->
    </div>
</div>
